module.exports = require("core-js-pure/features/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/symbol/iterator.js
// module id = 622
// module chunks = 0